/*
 * Author M. Atoar Rahman
 * Title: Partner Current Stock
 * Description: Page for Partner Current Stock
 * Date: 13/07/2022
 */

import { useAuth } from '../../contexts/AuthContext';
import { CurrentStockProvider } from '../partner/currentStock/ContextAPI';
import Index from '../partner/currentStock/Index';
import PermissionDenied from './PermissionDenied';

export default function PartnerCurrentStock() {
    // Route Permission
    const { auth } = useAuth();
    const { route_permissions } = auth;
    if (!route_permissions['partner-current-stock']) return <PermissionDenied />;

    return (
        <CurrentStockProvider>
            <Index />
        </CurrentStockProvider>
    );
}
